// extracted by mini-css-extract-plugin
export default {"hover_underline":"tableView_hover_underline__HFkKi","table_wrapper":"tableView_table_wrapper__qAG2+","table":"tableView_table__iVUFr"};